import axios from 'axios';

const apiClient = axios.create({
  headers: {
    'X-Internal-Client': true
  }
});

// Base URL for your API
const baseUrl = process.env.REACT_APP_BASE_URL || 'https://api.bizzboy.in/api'; // replace with your actual base URL

// API Service
const ApiService = {
  // Get Today's Result
  getTodayResult: async () => {
    return apiClient.get(`${baseUrl}/results/today`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching today\'s result:', error);
        throw error;
      });
  },

  // Get Last Day's Result
  getLastDayResult: async () => {
    return apiClient.get(`${baseUrl}/results/last-day`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching last day\'s result:', error);
        throw error;
      });
  },

  // Get Previous Result for a specific site and number of days
  getPreviousResult: async (siteId, days) => {
    return apiClient.get(`${baseUrl}/results/previous-days/${siteId}?days=${days}`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching previous result:', error);
        throw error;
      });
  },

  // Get Site Time Mapping
  getGameConfigs: async () => {
    return apiClient.get(`${baseUrl}/games/configs/active`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching site time mapping:', error);
        throw error;
      });
  },

};

export default ApiService;
